export class Response401Exception extends Error {}
